export const normalizeColors = (value) => {
  let colors = value;
  if (typeof colors === "string") {
    try {
      colors = JSON.parse(colors);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(colors)) return [];
  return colors.filter((color) => typeof color === "string" && /^#[\da-f]{6}$/i.test(color)).slice(0, 7);
};

export const normalizeGoals = (value) => {
  let goals = value;
  if (typeof goals === "string") {
    try {
      goals = JSON.parse(goals);
    } catch {
      return [];
    }
  }
  return Array.isArray(goals) ? goals.filter((goal) => typeof goal === "string") : [];
};
